import { render, staticRenderFns } from "./ot-dialog.vue?vue&type=template&id=72b93f43&"
import script from "./ot-dialog.vue?vue&type=script&lang=js&"
export * from "./ot-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports